import TrimRecordingLogic from '../../components/RecordingFeatures/TrimRecording'

const TrimRecordingPage = () => {

    return (
        <div className="vr-edit-page">
            <TrimRecordingLogic />
        </div>
    );
};

export default TrimRecordingPage;
